import React from 'react';

const Skills = () => {
  const skillCategories = [
    {
      title: "Programming Languages",
      skills: [
        { icon: "fab fa-python", name: "Python" },
        { icon: "fab fa-java", name: "Java" },
        { icon: "fas fa-code", name: "C" },
        { icon: "fab fa-js", name: "JavaScript" },
        { icon: "fas fa-database", name: "SQL" },
        { icon: "fab fa-html5", name: "HTML/CSS" }
      ]
    },
    {
      title: "ML & Data Science",
      skills: [
        { icon: "fas fa-brain", name: "PyTorch" },
        { icon: "fas fa-robot", name: "TensorFlow" },
        { icon: "fas fa-chart-line", name: "NumPy" },
        { icon: "fas fa-table", name: "Pandas" },
        { icon: "fas fa-eye", name: "OpenCV" }
      ]
    },
    {
      title: "Cloud & Infrastructure",
      skills: [
        { icon: "fab fa-aws", name: "AWS" },
        { icon: "fab fa-google", name: "GCP" },
        { icon: "fab fa-docker", name: "Docker" },
        { icon: "fas fa-cube", name: "Kubernetes" },
        { icon: "fab fa-linux", name: "Linux" },
        { icon: "fab fa-git-alt", name: "Git" }
      ]
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2 className="section-title">Skills & Technologies</h2>
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category">
              <h3 className="category-title">{category.title}</h3>
              <div className="skill-items">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <i className={skill.icon}></i>
                    <span>{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;

